"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const react_i18next_1 = require("react-i18next");
const ShareModal_1 = require("../ShareModal");
const FinishScreenWeb_1 = __importDefault(require("../common/FinishScreenWeb"));
const myFlightsHelper_1 = require("../../services/myFlightsHelper");
const PublishFlightSuccessWeb = () => {
    const flightData = (0, react_redux_1.useSelector)(selectors_1.getFlightDetails);
    const userDetails = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const userIsFlightPilot = userDetails?.id === flightData?.pilot?.app_user?.id;
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    if (!flightData)
        return (0, jsx_runtime_1.jsx)("div", {});
    const flightUrl = (0, myFlightsHelper_1.getFlightUrl)(flightData);
    let subtitle = null;
    if (userIsFlightPilot) {
        subtitle = t('success_info_page.flight_published');
    }
    else {
        subtitle = t('success_info_page.request_published');
    }
    return ((0, jsx_runtime_1.jsx)(FinishScreenWeb_1.default, { type: "Success", title: t("success_info_page.success"), subtitle: subtitle, showMyFlightsBtn: true, children: (0, jsx_runtime_1.jsxs)("div", { className: "success-buttons", children: [flightData?.request ?
                    (0, ShareModal_1.renderPostButtons)(flightUrl, t, (0, myFlightsHelper_1.renderPassengerRequestPostTitle)(flightData, t), undefined)
                    :
                        (0, ShareModal_1.renderPostButtons)(flightUrl, t, (0, myFlightsHelper_1.renderPilotFlightPostTitle)(flightData, t), undefined), (0, ShareModal_1.renderCopyLinkButton)(flightUrl, t, undefined)] }) }));
};
exports.default = PublishFlightSuccessWeb;
